import { AbstractControl } from '@angular/forms';
import { PlateValidator } from './plate.validator';

export function PlateFormValidator(formControl: AbstractControl): any {

  const plate = formControl.get('plate').value;

  let errorsPlate = { plateIsInvalid: false };

  if (formControl && formControl.value && !PlateValidator.isValidPlate(plate)) {
    errorsPlate = { plateIsInvalid: true };
  }
  if (plate === null || plate === '') {
    errorsPlate = { plateIsInvalid: false };
  }
  formControl.get('plate')
    .setErrors(errorsPlate);
}
